import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys.ts';
import { supabase } from '../../lib/supabase.ts';

/** The signed-in user's own profile (name and theme). RLS returns only rows the caller may read. */
export function useProfileQuery(userId: string | null) {
  return useQuery({
    queryKey: queryKeys.profile(userId ?? ''),
    enabled: userId !== null,
    queryFn: async () => {
      const { data, error } = await supabase()
        .from('profiles')
        .select('id, email, full_name, theme_preference')
        .eq('id', userId ?? '')
        .single();
      if (error) throw new Error(`Couldn't load your profile: ${error.message}`);
      return data;
    },
  });
}
